import { render, staticRenderFns } from "./ShowContractPartner.vue?vue&type=template&id=a42de970&scoped=true"
import script from "./ShowContractPartner.vue?vue&type=script&lang=js"
export * from "./ShowContractPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42de970",
  null
  
)

export default component.exports